import { Button, ErrorMessage, Spinner } from "../../../../../widgets";
import { ControlType, FetchStatus, IEntity } from "../../../../../base/types";
import { SubmitButtonProperties, useSubmitButtonProperties } from "./SubmitButtonProperties";

import { DraftSubmitButtonComponent } from "./DraftSubmitButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../../base/models";
import { Registry } from "../../../../../base/register";
import { useFormikContext } from "formik";

export const SubmitButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useSubmitButtonProperties(props);
    const { isSubmitting } = useFormikContext<IEntity>() || {}

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Button
        {...properties}
        className={className}
        iconClassName="me-1"
        isLoading={isSubmitting}
        disabled={properties?.disabled || isSubmitting}
    >
        {children}
    </Button>
}

Registry.addControl({
    id: "0234cf56-a6d7-4032-95d9-f63462ae4321",
    name: "Submit Button",
    type: ControlType.SubmitButton,
    properties: SubmitButtonProperties,
    component: SubmitButtonComponent,
    draftComponent: DraftSubmitButtonComponent
})
